import type { MyIpItem } from '$/domains/myIp/types';
import type { InputPanelRoleItem } from './types';

/** 将资产库角色 IP 转成输入框角色预览数据，头像使用接口返回的 avatar_url。 */
export function mapMyIpToInputPanelRole(item: MyIpItem): InputPanelRoleItem {
  return {
    id: item.ipId,
    name: item.name,
    description: item.summary,
    scope: item.assetType === 'official' ? 'official' : 'personal',
    ...(item.avatarUrl ? { avatar: item.avatarUrl } : {}),
  };
}

/** 合并资产库新增角色并按 IP ID 去重，保留输入框中已经选择的角色。 */
export function mergeMyIpInputRoles(
  current: InputPanelRoleItem[],
  items: MyIpItem[],
): InputPanelRoleItem[] {
  const roles = new Map(current.map((role) => [role.id, role]));
  items.forEach((item) => roles.set(item.ipId, mapMyIpToInputPanelRole(item)));
  return Array.from(roles.values());
}
